/**
 * 全局搜索「最近打开」（方案 Q9、§5）：存在本机 localStorage，按用户分键，最多 8 条，退出登录时清。
 * 只存类型、id、名字；打开前不再校验权限（点开时页面自己会做）。localStorage 不可用时照常工作，只是不记。
 */
import { isDeliberateSignOut } from '@/utils/authEvents'
import { isEntitySearchType, type EntitySearchType } from './searchTypes'

const PREFIX = 'globalSearch:recent:'
export const MAX_RECENT = 8

export interface RecentItem {
  type: EntitySearchType
  id: string
  label: string
}

function isRecentItem(v: unknown): v is RecentItem {
  const r = v as RecentItem | null
  return !!r && typeof r.id === 'string' && typeof r.label === 'string' && typeof r.type === 'string'
    && isEntitySearchType(r.type)
}

export function readRecent(userId: string): RecentItem[] {
  try {
    const raw = localStorage.getItem(PREFIX + userId)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter(isRecentItem).slice(0, MAX_RECENT) : []
  } catch {
    return []
  }
}

export function pushRecent(userId: string, item: RecentItem): void {
  const next = [item, ...readRecent(userId).filter((r) => !(r.type === item.type && r.id === item.id))].slice(0, MAX_RECENT)
  try {
    localStorage.setItem(PREFIX + userId, JSON.stringify(next))
  } catch {
    // 存不了（隐私模式、配额满）就不记
  }
}

export function clearAllRecent(): void {
  try {
    const keys: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key?.startsWith(PREFIX)) keys.push(key)
    }
    keys.forEach((key) => localStorage.removeItem(key))
  } catch {
    // 同上
  }
}

// 主动退出才清；401（会话过期）后通常是同一个人重新登录，留着
if (typeof window !== 'undefined') {
  window.addEventListener('auth:unauthorized', (event) => {
    if (isDeliberateSignOut(event)) clearAllRecent()
  })
}
